import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {
 
    },
    actions: {
        fetchLivraisons(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/livraisons', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        
    },
}
